import React from "react";
import Reveal from "./Reveal";

// SEZIONE 5 — Numeri
const STATS = [
  { value: "12", label: "funzionalità in un'unica piattaforma" },
  { value: "< 2 min", label: "per essere operativo" },
  { value: "2026", label: "calcoli fiscali sempre aggiornati alle norme in vigore" },
];

export default function StatsBand() {
  return (
    <section className="stats" id="numeri">
      <div className="container">
        <div className="stats-grid">
          {STATS.map((s, i) => (
            <Reveal key={s.label} className="stat" delay={i * 80}>
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
